import React, { Component } from 'react'
import { Menu, Checkbox, Dropdown, Button, Icon } from 'antd'
import { filetypes } from '../../../constants'

export default class extends Component {
  handleChange = (e) => {
    const { addFilesTypeFilter, removeFilesTypeFilter } = this.props

    if (e.target.checked === true) {
      addFilesTypeFilter(filetypes[e.target.name].extensions)
    } else {
      removeFilesTypeFilter(filetypes[e.target.name].extensions)
    }
  }

  render () {
    const { filters } = this.props

    const overlay = (
      <Menu>
        { Object.keys(filetypes).map(type =>
          <Menu.Item key={type}>
            <Checkbox
              name={type}
              onChange={this.handleChange}
              checked={filters.ext.includes(filetypes[type].extensions[0])}
            >{ filetypes[type].name }</Checkbox>
          </Menu.Item>
        ) }
      </Menu>
    )
    return (
      <Dropdown overlay={overlay} trigger={['click']} placement='bottomLeft'>
        <Button>File Type <Icon type='down' /></Button>
      </Dropdown>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Parts/FilterType/FilterType.jsx